import React from 'react';

import { BaseIconProps } from '.';

export const Bed = ({ fill }: BaseIconProps) => (
  <path
    d="m 50.537824,9.1885 h -24.5004 a 1.5360251,1.536 0 0 0 -1.537025,1.531 v 13.783 H 6.1260998 V 1.5315 A 1.5360251,1.536 0 0 0 4.5950748,5e-4 H 1.5310249 A 1.5360251,1.536 0 0 0 -8.3478315e-8,1.5315 v 33.691 A 1.5360251,1.536 0 0 0 1.5310249,36.7535 h 3.0630499 a 1.5360251,1.536 0 0 0 1.531025,-1.531 v -4.594 H 55.131898 v 4.594 a 1.5360251,1.536 0 0 0 1.531026,1.531 h 3.063049 a 1.5360251,1.536 0 0 0 1.531026,-1.531 V 19.9085 A 10.715175,10.715 0 0 0 50.537824,9.1885 Z M 15.31425,21.4395 a 6.1260999,6.126 0 1 0 -6.1261004,-6.126 6.1310999,6.131 0 0 0 6.1261004,6.126 z"
    transform="matrix(17.630638,0,0,15.998172,3.281112e-6,246.00159)"
    fill={fill}
  />
);
